import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function PaymentRedirect() {
  const location = useLocation();
  const paymentUrl = location.state?.payment_url;
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (paymentUrl) {
      setRedirecting(true);
      // Brief delay for UX - show loading state before redirect
      const timer = setTimeout(() => {
        window.location.href = paymentUrl;
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [paymentUrl]);

  const handleManualRedirect = () => {
    if (paymentUrl) {
      window.location.href = paymentUrl;
    }
  };

  if (!paymentUrl) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(100vh - 80px)",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <Typography fontSize="20px" fontWeight="600" color="error" sx={{ my: 2 }}>
          Payment URL not found. Please try again.
        </Typography>
        <Button variant="contained" href="/">
          Return to Home
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 80px)",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <CircularProgress size={60} sx={{ mb: 3 }} />
      
      <Typography fontSize="24px" fontWeight="600" sx={{ mb: 2 }}>
        Redirecting to payment...
      </Typography>
      
      <Typography fontSize="16px" color="text.secondary" sx={{ mb: 4 }}>
        Please wait while we redirect you to the payment gateway.
      </Typography>

      {redirecting && (
        <Button 
          variant="outlined" 
          onClick={handleManualRedirect}
          sx={{ mt: 2 }}
        >
          Click here if not redirected automatically
        </Button>
      )}
    </Box>
  );
}
